import RoleLogin from "@/pages/RoleLogin";

export default function DoctorLogin() {
  return (
    <RoleLogin role="DOCTOR" portalLabel="Doctor Portal" dashboardPath="/doctor/dashboard" testPrefix="doctor" />
  );
}
